import { useEffect } from "react";
import appConstants from "../_services/applicationConstant";

export function useVersionCheck() {
  // useEffect(() => {
    const checkVersion = async () => {
      try {
        // const res = await fetch('/version.json', { cache: 'no-cache' });
        // const data = await res.json();
         const currentVersion = localStorage.getItem('app_version');
        const newVersion = appConstants.version;
        
        if (currentVersion && currentVersion !== newVersion) {
          console.log('New version detected — refreshing...');
          localStorage.setItem('app_version', newVersion);
          window.location.reload(true);
        } else {
          localStorage.setItem('app_version', newVersion);
        }
      } catch (err) {
        console.error('Version check failed', err);
      }
    };

    const interval = setInterval(checkVersion, 30000); // every 30s
    checkVersion();

    return () => clearInterval(interval);
  // }, []);
}
